import UserAPI from "@api/User.api";
import useUserStore from "@store/user.store";
import dayjs from "dayjs";
import { useEffect } from "react";

const useGetUserInformation = () => {
  const { isLogin, setAffiliationInformation, affiliationInformation } =
    useUserStore();

  useEffect(() => {
    if (isLogin && !affiliationInformation) {
      UserAPI.getMeInformation().then((res) =>
        setAffiliationInformation({
          ...res,
          lastUpdatedAt: dayjs().toISOString(),
        }),
      );
    }
  }, [isLogin, setAffiliationInformation, affiliationInformation]);

  return { affiliationInformation };
};

export default useGetUserInformation;
